import React from 'react';
import { cn } from './cn';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  /** Tighter sizing — use inside cards. */
  compact?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon, title, description, action, className, compact = false,
}) => (
  <div
    className={cn(
      'flex flex-col items-center text-center mx-auto',
      compact ? 'py-8 max-w-sm' : 'py-14 max-w-md',
      className,
    )}
  >
    {icon && (
      <div
        className={cn(
          'mb-4 rounded-2xl bg-surface-2 text-ink-subtle flex items-center justify-center',
          compact ? 'h-10 w-10' : 'h-14 w-14',
        )}
        aria-hidden
      >
        {icon}
      </div>
    )}
    <h3 className={cn('text-ink font-semibold', compact ? 'text-heading-sm' : 'text-heading-md')}>
      {title}
    </h3>
    {description && (
      <p className={cn('text-ink-subtle mt-1.5', compact ? 'text-body-sm' : 'text-body-md', 'max-w-prose-narrow')}>
        {description}
      </p>
    )}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
